import { useState } from 'react'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { ChefHat } from 'lucide-react'
import toast from 'react-hot-toast'

const API = import.meta.env.VITE_API_URL || ''

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') || ''
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [password2, setPassword2] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (password !== password2) { toast.error('A két jelszó nem egyezik'); return }
    if (password.length < 6) { toast.error('A jelszó legalább 6 karakter legyen'); return }
    setLoading(true)
    try {
      const res = await fetch(`${API}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: password }),
      })
      if (!res.ok) {
        const err = await res.json()
        toast.error(err.detail || 'Lejárt vagy érvénytelen link')
        return
      }
      toast.success('Jelszó sikeresen megváltoztatva!')
      navigate('/login')
    } catch {
      toast.error('Hiba történt, próbáld újra')
    } finally {
      setLoading(false)
    }
  }

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6" style={{ background: '#F0FAF7' }}>
        <div className="text-center">
          <p className="text-gray-500 mb-4">Érvénytelen link.</p>
          <Link to="/login" className="font-semibold hover:underline" style={{ color: '#5BB8A0' }}>Bejelentkezés</Link>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: '#F0FAF7' }}>
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: '#5BB8A0' }}>
            <ChefHat className="w-5 h-5 text-white" />
          </div>
          <span className="font-bold text-lg" style={{ color: '#1E2D27' }}>CukrászDoc</span>
        </div>

        <h1 className="text-2xl font-bold mb-1" style={{ color: '#1E2D27' }}>Új jelszó beállítása</h1>
        <p className="text-sm text-gray-500 mb-8">Add meg az új jelszavad.</p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="label">Új jelszó</label>
            <input
              className="input"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoComplete="new-password"
            />
          </div>
          <div>
            <label className="label">Jelszó megerősítése</label>
            <input
              className="input"
              type="password"
              placeholder="••••••••"
              value={password2}
              onChange={e => setPassword2(e.target.value)}
              required
              autoComplete="new-password"
            />
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? 'Mentés...' : 'Jelszó mentése'}
          </button>
        </form>
      </div>
    </div>
  )
}
